import React, { forwardRef } from 'react';

import styles from './Tooltip.module.scss';

interface TooltipProps {
  content: string;
  transform: string;
}

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(({ content, transform }, ref) => {
  return (
    <div
      className={styles.tooltip}
      style={{
        transform,
      }}
      ref={ref}
    >
      {content}
    </div>
  );
});

export default Tooltip;
